<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- Logo Section -->
      <div class="footer-logo footer-nav">
        <h3 class="do-hyeon-regular">
          AXIS<br>
          <span>천호제일감리교회 젊은이부</span><br>
          <span>
            Chenhojeil Methodist Church Young Adults
          </span>
        </h3>

        <div class="family-site-box">
          <div class="family-site-inner">
            <ul class="family-site-wrapper clearfix">
              <li class="family-site-item">
                <a target="_blank" href="https://www.instagram.com/cheonhojeil_axls">
                  <i class="bi bi-instagram"></i> AXIS 인스타그램
                </a>
              </li>
              <li class="family-site-item">
                <a target="_blank" href="https://www.youtube.com/@%EC%B2%9C%ED%98%B8%EC%A0%9C%EC%9D%BC%EA%B0%90%EB%A6%AC%EA%B5%90%ED%9A%8C%EC%A0%8A%EC%9D%80/streams">
                  <i class="bi bi-youtube" style="font-size: 16px;"></i> AXIS 유튜브
                </a>
              </li>
              <li class="family-site-item">
                <a target="_blank" href="http://www.chunhojeil.com/main/main.html">
                  <i class="bi bi-box-arrow-up-right" style="font-size: 14px;"></i> 본교회 홈페이지
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <!-- Navigation Section -->
<!--      <div class="footer-about footer-nav">-->
<!--        <h3>소개</h3>-->
<!--        <ul>-->
<!--          <li><a href="#">인삿말</a></li>-->
<!--          <li><a href="#">교회소개</a></li>-->
<!--        </ul>-->
<!--      </div>-->

      <!-- Social Media Section -->
<!--      <div class="footer-gallery footer-nav">-->
<!--        <h3>갤러리</h3>-->
<!--        <ul>-->
<!--          <li><a href="#">예배</a></li>-->
<!--          <li><a href="#">수련회</a></li>-->
<!--        </ul>-->
<!--      </div>-->

      <!-- Subscribe Section -->
<!--      <div class="footer-notice footer-nav">-->
<!--        <h3>젊은이부 소식</h3>-->
<!--        <ul>-->
<!--          <li><a href="#">공지사항</a></li>-->
<!--          <li><a href="#">주보</a></li>-->
<!--        </ul>-->
<!--      </div>-->
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped lang="scss">

.footer {
  //background-color: #f0f4f7;
  //background-color: #0eabc3;
  background-color: #7daab9;
  box-sizing: border-box;
  padding: 60px;
  //height: 220px;

  .footer-container {

    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    text-align: left;
    display: flex;
    box-sizing: border-box;
    padding: 10px;

    color: #fff;

    p {
      font-size: 14px;
      margin-top: 10px;
      line-height: 1.4;
    }

    .footer-nav {
      min-width: 25%;

      h3 {
        font-weight: 700;
        font-size: 16px;
      }

      ul {
        margin-top: 10px;
        li {
          box-sizing: border-box;
          padding: 5px 0;
          height: 30px;
          display: flex;
          align-items: center;
          a {
            font-size: 15px;
            font-weight: 400;
            color: #fff;
            opacity: .8;
          }
        }
      }

    }

    .footer-logo {
      h3 {
        font-size: 30px;
        span {
          font-size: 15px;
          font-weight: 400;
          opacity: .8;
        }
      }

      .family-site-box {
        .family-site-wrapper {
          .family-site-item {
            float: left;

            margin-right: 15px;

            &:last-child {
              margin-right: 0;
            }

            a {
              font-size: 14px;
              display: flex;
              align-items: center;

              i {
                margin-right: 8px;
              }

            }
          }
        }
      }
    }

    .footer-about {
    }

    .footer-gallery {
    }

    .footer-notice {
    }

  }
}

@media screen and (max-width: 1512px) {
  .footer {
    padding: 15px;
    height: auto;
  }
}

@media screen and (max-width: 768px) {
  //.footer {
  //  padding: 15px;
  //  height: auto;
  //}

  .footer .footer-container .footer-logo h3 {
    font-size: 24px;
  }

  .footer .footer-container .footer-logo h3 span {
    font-size: 14px;
  }
}

</style>